module.exports = {
  "country": "UK",
  "artist": "Scooch",
  "song": "Flying the Flag (For you)",
  "year": "2007",
  "place": "22",
  "spotify": "6UFFiCbEkd5p2XULVLOSVQ"
};